import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';

interface ManualPasteDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onPaste: (text: string) => void;
}

export function ManualPasteDialog({
  open,
  onOpenChange,
  onPaste,
}: ManualPasteDialogProps) {
  const [pasteText, setPasteText] = useState('');

  const handlePaste = () => {
    if (pasteText.trim()) {
      onPaste(pasteText);
      setPasteText('');
      onOpenChange(false);
    }
  };

  const handleCancel = () => {
    setPasteText('');
    onOpenChange(false);
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Paste Workflow</DialogTitle>
          <DialogDescription>
            Clipboard access is restricted. Please paste your workflow JSON below.
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <Textarea
            placeholder="Paste your workflow JSON here..."
            value={pasteText}
            onChange={(e) => setPasteText(e.target.value)}
            className="min-h-[200px] font-mono text-sm"
            autoFocus
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel}>
            Cancel
          </Button>
          <Button onClick={handlePaste} disabled={!pasteText.trim()}>
            Paste Workflow
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
